import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import * as _ from 'lodash-es';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-autocomplete-filter-model__old',
    templateUrl: './autocomplete-filter-model__old.component.html',
    styleUrls: ['./autocomplete-filter-model__old.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, FormsModule, RxReactiveFormsModule, MatAutocomplete, MatOption, MatError, AsyncPipe, TranslatePipe]
})
export class AutocompleteFilterModelOldComponent implements AfterViewInit {

    readonly label = input<string>();
    readonly error = input<string>();
    readonly placeholder = input<string>();
    readonly required = input<boolean>();
    readonly name = input<string>();

    @Input() ngModel: any;
    readonly ngModelChange = output<any>();

    readonly options = input<any[]>();
    readonly filterKey = input<string>('');
    readonly displayKey = input<string>('');
    readonly disabled = input<boolean>(false);

    get accessor(): (value: any) => any {
        return _.property(this.filterKey());
    }

    filteredOptions$: Subject<any[]> = new Subject<any[]>();
    displayWith = (value: any) => {
        if (value) {
            return typeof value === 'string' ? value : this.accessor(value);
        }
        else {
            console.log("ERROR : Autocomplete no value");
        }
    };

    ngAfterViewInit(): void {
        this.filteredOptions$.next(this._filter(this.ngModel));
    }

    filterChange() {
        this.filteredOptions$.next(this._filter(this.ngModel));
    }

    filter() {
        if (this.ngModel === '')
            this.ngModel = '';
    }

    private _filter(value: string | any): string[] | any[] {
        let filterValue = '';
        if (typeof value === 'string')
            filterValue = value.toLowerCase();
        else
            filterValue = this.accessor(value)?.toLowerCase();
        const options = this.options();
        if (options) {
            return options.filter(option => {
                if (typeof option === 'string') {
                    return option != undefined && !_.isEmpty(option) && this._compare(filterValue, option);
                } else {
                    return option != undefined && this.accessor(option) != undefined && !_.isEmpty(this.accessor(option)) && this._compare(filterValue, this.accessor(option));
                }
            });
        }
        else return [];
    }

    protected _compare(filterValue: string, option: string) {
        return (!_.isEmpty(filterValue)) ? option.toLowerCase().includes(filterValue) : true;
    }

    getLabel(option: any) {
        const displayKey = this.displayKey();
        return _.isString(option) ? option : !_.isEmpty(displayKey) ? _.get(option, displayKey) : this.accessor(option);
    }
}
